// Strict canonical form only: lowercase, dashed, as produced by `crypto.randomUUID()`.
// Callers that need case-insensitive or version-pinned UUID checks (custom-fetch,
// enterprise signup, branded transformation downloads) keep their own regexes.
const CANONICAL_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function isCanonicalUuid(value: string | undefined): value is string {
  return typeof value === "string" && CANONICAL_UUID_PATTERN.test(value);
}
